import { render, staticRenderFns } from "./app-refresh.vue?vue&type=template&id=2ad4a5ec&scoped=true&"
import script from "./app-refresh.vue?vue&type=script&lang=js&"
export * from "./app-refresh.vue?vue&type=script&lang=js&"
import style0 from "./app-refresh.vue?vue&type=style&index=0&id=2ad4a5ec&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad4a5ec",
  null
  
)

export default component.exports